import React from "react";
import { useNavigate } from "react-router-dom";
import UserDetails from "./UserDetails";
import { path } from "../../navigation/path";

const MyProfile: React.FC = () => {
  const navigate = useNavigate();
  const memberId = localStorage.getItem("member_id");

  if (!memberId) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 px-4 flex items-center justify-center">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-8 max-w-md text-center">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">My Information</h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            No member profile is linked to your account. Please contact an administrator.
          </p>
          <button
            onClick={() => navigate("/")}
            className="btn-primary px-6 py-2.5"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return <UserDetails forceMemberId={memberId} isOwnProfile />;
};

export default MyProfile;
